export const STATUS_LINE_LABELS = {
  ACTIVE: 'Active',
  NEW_SINCE_REPLAN: 'NEW',
  // DEV-2913: badge label for a row paused on a FE confirmation card.
  // Reads as "waiting on me", distinct from the type-derived "Running"
  // (which implies the row is doing work right now).
  AWAITING_CONFIRMATION: 'Awaiting',
  // DEV-2951: badge label for a step the model never invoked (planner
  // predicted a tool the run didn't need). Overrides the type-derived verb
  // ("Reading", "Running") so the row reads as "didn't run", not "ran".
  SKIPPED: 'Skipped',
};
